import { ReportFooter as AnnexIVFooter } from '../../../questionnaire/Report/ReportFooter/ReportFooter';
import { ReportHeader as AnnexIVHeader } from '../../../questionnaire/Report/ReportHeader/ReportHeader';
import { Divider } from '../../../ui/Divider/Divider';
import { RichTextArea } from '../../../ui/EditableInput/RichTextArea';
import { documentationSections } from './AnnexIV.consts';
import Signature from '../../../ui/Signature/Signature';
import { H2 } from '../../../ui/H2/H2';
import { useAnnexIVData } from '../../../../hooks/useAnnexIVData';
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux';
import { setAnnexIVField } from '../../../../store/slices/documentationSlice';

export const AnnexIV = () => {
  const { headerData, footerData } = useAnnexIVData();
  const dispatch = useAppDispatch();
  const { annexIVFields } = useAppSelector((state) => state.documentation);

  const handleChange = (label: string, value: string, section: string) => {
    dispatch(setAnnexIVField({ label, value, section }));
  };

  return (
    <div className="w-full h-full p-5">
      <AnnexIVHeader componentInfo={headerData} />
      <Divider classes="my-[34px]" />
      {documentationSections.map((section, index) => (
        <div key={section.title}>
          <div className="flex flex-col border border-gray-100 rounded-lg p-4">
            <H2 title={section.title} textSize="text-base" />
            <Divider classes="my-3.5" />
            {section.fields.map((field, index) => (
              <RichTextArea
                key={field.label}
                label={field.label}
                placeholder={field.placeholder}
                onChange={(value) =>
                  handleChange(field.label, value, section.title)
                }
                value={annexIVFields[field.label]?.value || ''}
                className={`${
                  index === section.fields.length - 1 ? '' : 'mb-4'
                }`}
              />
            ))}
          </div>
          {index === documentationSections.length - 1 ? null : (
            <Divider classes="my-[34px]" />
          )}
        </div>
      ))}
      <Divider classes="my-[34px]" />
      {/* <Signature text="Signature" dont need signature for now />
      <Divider classes="my-3.5" /> */}
      <AnnexIVFooter componentInfo={footerData} />
    </div>
  );
};
